import { request, requestUser } from "../../apis";

export const apiGetUserInfo = (): any =>
  requestUser("get", `/api/user/info`, null, true);

export const apiUpdateUserInfo = (params: any): any =>
  requestUser("put", `/api/user/update/info`, params, true);

export const apiGetUserOrderHistory = (params: any): any =>
  request("get", `/api/order/history`, params, true);

export const apiLogout = (): any =>
  requestUser("post", `/api/logout`, null, true);

export const apiGetGiftPoint = (): any =>
  requestUser("get", `/api/user/gift/point`, null, true);

export const apiGetGiftPointRecord = (params: any): any =>
  request("get", `/api/gift/point/record`, params, true);
